import { saveKnowYourCustomerAnswers } from '../api/saveKycAnswers';
import { KycAnswer } from '../types/KycTypes';
import { useAppSelector } from './hooks';
import useArnFromPath from './useArnFromPath';
import useSettings from './useSettings';

/**
 * Initializes a service for patching the KYC answers
 *
 * @returns service function for patching
 */
const useSaveKnowYourCustomerAnswers = () => {
    const { authenticationData } = useAppSelector((state) => state.authentication);
    const { kycTemplateVersion } = useAppSelector((state) => state.application);
    const { apiKey, proxyBaseUrl } = useSettings();
    const applicationReferenceNumber = useArnFromPath();

    return async (kycAnswers: KycAnswer[]) => {
        if (!authenticationData) {
            throw Error('Not authenticated');
        }

        return await saveKnowYourCustomerAnswers(
            proxyBaseUrl,
            apiKey,
            authenticationData,
            applicationReferenceNumber!,
            kycAnswers,
            kycTemplateVersion,
        );
    };
};

export default useSaveKnowYourCustomerAnswers;
